App.CourierSelectionComponent = Em.Component.extend
  classNames: [ 'courier-selection' ]

  classNameBindings: [ 'isSelected', 'isCurrent' ]

  isSelected: (->
    return false if @get('courier.isNew')
    @get('courier.id') is @get('selectedCourier.id')
  ).property(
    'courier.isNew',
    'courier.id',
    'selectedCourier',
    'selectedCourier.id')

  isCurrent: (->
    return false if @get('courier.isNew')
    @get('courier.id') is @get('currentCourier.id')
  ).property(
    'courier.isNew',
    'courier.id',
    'currentCourier.id',
    'selectedCourier',
    'selectedCourier.id')

  sendClickAction: (->
    @sendAction('onClick', @get('courier'))
  ).on('click')
